import { defineStore } from 'pinia'
import type { Organization } from '@/types/organization'
import { ref } from 'vue'
import axios from 'axios'
import type { CreateOrganization } from '@/model/create-organization.model.ts'
import { useUserStore } from '@/store/user.store'
import { axiosClient } from '@/utils/axios-client'

export const useOrganizationStore = defineStore('organisation', () => {
  const user = useUserStore()
  const organizations = ref<Organization[]>([])
  const loadingOrganizations = ref(false)

  async function fetchOrganizations(refresh = false) {
    // Prevent over fetchting
    // TODO - make it less jank
    if ((loadingOrganizations.value || organizations.value.length > 0) && !refresh) {
      return
    }
    loadingOrganizations.value = true
    const response = await axios.get<Organization[]>('/auth/api/organisatie/all')
    organizations.value = response.data

    // Attach user organization to organizations to choose from
    if (user.currentUser?.userOrganisatie) {
      organizations.value = [user.currentUser?.userOrganisatie, ...organizations.value]
    }

    loadingOrganizations.value = false
  }

  async function createOrganization(organization: CreateOrganization) {
    if (organization == null) return

    await axios.post('/auth/api/organisatie', organization)
    await fetchOrganizations(true)
  }

  async function fetchNewClients() {
    const response = await axiosClient.request<Organization[]>({
      url: '/auth/api/organisatie/client/search',
      method: 'GET',
    })

    return response.data
  }

  return {
    organizations,
    fetchNewClients,
    fetchOrganizations,
    createOrganization,
  }
})
